import { CATEGORY_LABELS, type EmailCategory } from '@/shared/triage/vocabulary';
import { Badge, type Tone } from '@/shared/ui/Badge';
import { cn } from '@/shared/utils/cn';

/**
 * The category, coloured by what it means for the person reading the inbox.
 *
 * Four tones and not fifteen colours: red is the one that must catch the eye
 * (`sospechoso`), amber is money and doubt, blue is the mail that becomes work (a quote
 * request, an offer), neutral is everything routine, junk included. Fifteen
 * distinguishable colours would be fifteen colours nobody can distinguish.
 */
const TONES: Record<EmailCategory, Tone> = {
  sospechoso: 'danger',
  aviso_bancario: 'warn',
  pedido_ambiguo: 'warn',
  factura_proveedor: 'neutral',
  solicitud_albaran: 'neutral',
  solicitud_factura: 'neutral',
  pedido_con_albaran: 'neutral',
  pedido_sin_albaran: 'neutral',
  solicitud_presupuesto: 'info',
  oferta_proveedor_respuesta: 'info',
  oferta_proveedor_publicidad: 'neutral',
  gestion_interna: 'neutral',
  otro: 'neutral',
  // Contract v10.24. Victor's own purchasing, not new work; and junk is routine.
  confirmacion_pedido_proveedor: 'neutral',
  correo_basura: 'neutral',
};

export function CategoryBadge({
  category,
  size = 'md',
  wrap = false,
}: {
  category: EmailCategory;
  size?: 'md' | 'lg';
  /** In a table column: «Confirmación de pedido a proveedor» (v10.24) on one line took
   * 226 px at 1280 and left «Asunto» with 71. Two lines are fine there. */
  wrap?: boolean;
}) {
  return (
    <Badge
      tone={TONES[category]}
      wrap={wrap}
      className={cn(size === 'lg' && 'px-3 py-1 text-[14px]')}
    >
      {CATEGORY_LABELS[category]}
    </Badge>
  );
}
